module.exports = __webpack_public_path__ + "img/about-02.95ded25f.jpg";